import { Button, Tooltip, Space, Typography } from "antd";
import Date from "../../components/tables/Date";
import FullName from "../../components/tables/FullName";
const { Text } = Typography;
const generateColumns = (
  section,
  intl,
  onSyncRow,
  activeRowId,
  syncRowLoading,
  branchPath,
  onSelectPatient,
  hasEditorPermission,
  jobId
) => {
  const actionsColumn = (entityId, isSchedules) => {
    return {
      title: "actions",
      render: ({ record }) =>
        record[entityId] && (
          <Space horizontal={true}>
            <Button
              onClick={() => {
                onSyncRow(record[entityId]);
              }}
              type="text"
              loading={
                (syncRowLoading || !!jobId) && activeRowId === record[entityId]
              }
              disabled={!hasEditorPermission || !!jobId}
            >
              {intl.formatMessage({
                id: `app.actions.sync`,
              })}
            </Button>
            {isSchedules && (
              <Button
                onClick={() => {
                  onSelectPatient(record);
                }}
                type="text"
                //loading={syncRowLoading && activeRowId === record[entityId]}
              >
                {intl.formatMessage({
                  id: `app.actions.showErrors`,
                })}
              </Button>
            )}
          </Space>
        ),
    };
  };

  switch (section) {
    case "employees":
      return [
        {
          title: "fullname",
          render: ({ record }) => {
            const name = {
              first_name: record.first_name || "",
              surename: record.surename || "",
            };
            return (
              <FullName
                record={name}
                customLocation={`employees/${record.employee_id}`}
              />
            );
          },
          sortIndex: "surename",
          sorter: true,
        },
        {
          title: "error_code",
          sortIndex: "error_code",
          sorter: true,
          ellipsis: true,
          width: "120px",
        },
        {
          title: "error_message",
          sortIndex: "error_message",
          sorter: true,
          ellipsis: true,
          render: ({ record }) => (
            <Tooltip
              className="content"
              placement="topRight"
              title={record?.error_message}
            >
              {record?.error_message}
            </Tooltip>
          ),
        },
        {
          title: "updatedAt",
          sortIndex: "updated_at",
          ellipsis: true,
          render: ({ record }) => (
            <Date text={record?.updated_at} format={"HH:mm DD/MM/YYYY"} />
          ),
          width: "160px",
          sorter: true,
          sortIndex: "updated_at",
        },
        actionsColumn("employee_id"),
      ];
    case "report":
      return [
        {
          title: "Employee Name",
          dataIndex: "employeeName",
          key: "employeeName",
          ellipsis: true,
        },
        {
          title: "Employee ID",
          dataIndex: "employeeId",
          key: "employeeId",
          ellipsis: true,
        },
        {
          title: "Patient Name",
          dataIndex: "patientName",
          key: "patientName",
          ellipsis: true,
        },
        {
          title: "Patient ID",
          dataIndex: "patientId",
          key: "patientId",
          ellipsis: true,
        },
        { title: "Type", dataIndex: "type", key: "type", ellipsis: true },
        {
          title: "Timestamp",
          dataIndex: "timestamp",
          key: "timestamp",
          ellipsis: true,
        },
        {
          title: "Action Type",
          dataIndex: "actionType",
          key: "actionType",
          ellipsis: true,
        },
        {
          title: "Error Code",
          dataIndex: "errorCode",
          key: "errorCode",
          ellipsis: true,
        },
        {
          title: "Error Message",
          dataIndex: "errorMessage",
          key: "errorMessage",
          ellipsis: true,
        },
        {
          title: "Sync Timestamp",
          dataIndex: "syncTimestamp",
          key: "syncTimestamp",
          ellipsis: true,
        },
        actionsColumn,
      ];

    case "schedules":
      return [
        {
          title: "patientName",
          render: ({ record }) => {
            const name = {
              first_name: record.patient_first_name || "",
              surename: record.patient_surename || "",
            };
            return (
              <FullName
                record={name}
                customLocation={`patients/${record.patient_id}`}
              />
            );
          },
          sortIndex: "patient_surename",
          sorter: true,
        },
        {
          title: "employeeName",
          render: ({ record }) => {
            const name = {
              first_name: record.employee_first_name || "",
              surename: record.employee_surename || "",
            };
            return (
              <FullName
                record={name}
                customLocation={`employees/${record.employee_id}`}
              />
            );
          },
          sortIndex: "employee_surename",
          sorter: true,
        },
        {
          title: "year",
          sortIndex: "year",
          sorter: true,
          width: "80px",
        },
        {
          title: "month",
          sortIndex: "month",
          sorter: true,
          width: "90px",
        },
        {
          title: "error_code",
          sortIndex: "error_code",
          sorter: true,
          ellipsis: true,
          width: "120px",
        },
        {
          title: "error_message",
          sortIndex: "error_message",
          sorter: true,
          ellipsis: true,
          render: ({ record }) => (
            <Tooltip
              className="content"
              placement="topRight"
              title={record?.error_message}
            >
              {record?.error_message}
            </Tooltip>
          ),
        },
        {
          title: "has_errors",
          sortIndex: "has_event_status_errors",
          render: ({ record }) => {
            return (
              <Text>
                {intl.formatMessage({
                  id: record.has_event_status_errors
                    ? `app.dataSelect.yes`
                    : `app.dataSelect.no`,
                })}
              </Text>
            );
          },
          filters: [
            {
              text: intl.formatMessage({
                id: `app.dataSelect.yes`,
              }),
              value: true,
            },
            {
              text: intl.formatMessage({
                id: `app.dataSelect.no`,
              }),
              value: false,
            },
          ],
          sorter: true,
          width: "150px",
        },
        {
          title: "updatedAt",
          sortIndex: "updated_at",
          // sorter: true,
          ellipsis: true,
          render: ({ record }) => (
            <Date text={record?.updated_at} format={"HH:mm DD/MM/YYYY"} />
          ),
          width: "160px",
        },
        actionsColumn("patient_id", true),
      ];

    case "troms":
      return [
        {
          title: "fullname",
          render: ({ record }) => {
            const name = {
              first_name: record.first_name || "",
              surename: record.surename || "",
            };
            return (
              <FullName
                record={name}
                customLocation={`${branchPath}/patients/${record.patient_id}`}
              />
            );
          },
          sortIndex: "surename",
          sorter: true,
        },
        {
          title: "error_code",
          sortIndex: "error_code",
          sorter: true,
          ellipsis: true,
          width: "120px",
        },
        {
          title: "error_message",
          sortIndex: "error_message",
          sorter: true,
          ellipsis: true,
          render: ({ record }) => (
            <Tooltip
              className="content"
              placement="topRight"
              title={record?.error_message}
            >
              {record?.error_message}
            </Tooltip>
          ),
        },
        {
          title: "updatedAt",
          sortIndex: "updated_at",
          // sorter: true,
          ellipsis: true,
          render: ({ record }) => (
            <Date text={record?.updated_at} format={"HH:mm DD/MM/YYYY"} />
          ),
          width: "150px",
        },
        actionsColumn("order_id"),
      ];
    default:
      return [];
  }
};

export default generateColumns;
